import $ from 'jquery';
//import 'slick-carousel';
import debounce from 'lodash/debounce';
import 'jquery-mask-plugin';
import 'jquery-doubletaptogo';
import cookies from 'js-cookie';
import customPaging from './slick/custom-paging';
import './slick-carousel';
import './modal';
import './enterable';
import './track-video';
import './slick-slider';
import './accordion';
import './dropdown';
import './nav-active';
import './horizontal-scroll';
// import './back-to-top';
import './vanish/vanish';
import './focus-to';
import './close-banner';
import './progress-ring';
import './switch-class';
import './toggle-text';
import './fixed-table-header';
import './slides';
import './slidedown';
import './tabs';
import noFocus from './no-focus';
import './toggle-change';
import './toggle-display';
import './toggle-reveal';
import './char-counter';
import './countdown';
import './product-opt-view';
import './gift-cert-update';
import './tooltip';
import './scroll-to-top';
import './cc-mask';
import './product-filter-search';
import './cc-exp-mask';
import './progressive-btn';
import './lazy-ajax';
import './ab-controls';
import './impressions-controls';
import './rating-scale/rating-scale';
import './recs-pop-out';
import '../abtests/ab724/plp-left-nav-filter-redesign-ab724';
import './fixed-header';
import '../abtests/ab4266';


// import './toggle-display';
// import './product-size-change';
// import './product-add-to-bag';
// import './product-color-change';
// import './product-oos';

const initModules = () => {
  noFocus();
  $('.js-fixed-header').fixedHeader();
  $('.js-horizontal-scroll').horizontalScroll();
  $('.js-tabs').tabs();
  $('.js-slick').slick();
  $('.js-carousel-editors-list').each(function(i, item) {
    const $item = $(item);
    $item.slickSlider({
      slidesToShow: 4,
      slidesToScroll: 4,
      nextArrow: $item.find('.js-slick-next'),
      prevArrow: $item.find('.js-slick-prev')
    })
  })
  $('.js-carousel-single-slide').slick({
     dots: false,
     infinite: true,
     fade: true,
     arrows: false,
     cssEase: 'linear',
     autoplay: true,
     autoplaySpeed: 1500,
   });
  $('.js-carousel-beauty-lp').each(function (i, item) {
    const $item = $(item);
    $item.slickSlider({
      lazyLoad: 'progressive',
      nextArrow: $item.find('.slick-next'),
      prevArrow: $item.find('.slick-prev'),
      slidesToShow: 5,
      slidesToScroll: 5,
    });
  });
  // A/B Test 944 start
  $('.js-ab944-carousel').each(function (i, item) {
    const $item = $(item);
    $item.slickSlider({
      lazyLoad: 'ondemand',
      nextArrow: $item.find('.slick-next'),
      prevArrow: $item.find('.slick-prev'),
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
      ],
    });
  });
  // A/B Test 944 end
  // product recs purchase with
  $('.js-carousel-pw').each(function () {
    const $purchaseWith = $(this);
    $purchaseWith.slickSlider({
      lazyLoad: 'progressive',
      slidesToShow: 4,
      slidesToScroll: 4,
      nextArrow: $purchaseWith.find('.slick-next'),
      prevArrow: $purchaseWith.find('.slick-prev'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 822,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 2,
          }
        }
      ]
    });
  });

  $('.js-carousel-ctl').slick({
    dots: true,
    customPaging,
    dotsClass: "image-carousel__dots",
    appendDots: $(".image-carousel__dots-container"),
    lazyLoad: 'ondemand',
    slidesToShow: 2,
    slidesToScroll: 2,
    accessibility: true
  });
  $('.js-carousel-ctl-order').slick({
    dots: true,
    customPaging,
    dotsClass: "image-carousel__dots",
    appendDots: $(".image-carousel__dots-container"),
    slidesToShow: 4,
    slidesToScroll: 4,
    accessibility: true
  });
  $('.js-carousel-si-order').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    accessibility: true
  });

  $('.js-beauty-nav').slickSlider({
    dots: false,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      },
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      }
    ]
  });

  $('.js-kj-slick').each(function (i, item) {
    const $item = $(item);
    $item.slickSlider({
      dots: true,
      appendDots: $item.find('.js-kj-slick-dots'),
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      nextArrow: $item.find('.js-slick-next'),
      prevArrow: $item.find('.js-slick-prev')
    });
  });

  $('.js-slides-slick-oos').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    showZoomTab: false,
    centerMode: true,
    productZoomBtn: '.product-zoom__btn',
    productZoomBtnActive: 'product-zoom__btn--active',
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  })
  // for all inclusive modal
  $('.js-duties-modal').on('click', function() {
    $.modal({
      url: '/fw/dialog/AllInclusiveModal.jsp',
      triggerOpen: open,
      returnFocus: $(this),
    });
  });

  // for all inclusive banner modal
  // check's if banner exists for all inclusive
  if($('#fwDutyBanner').length > 0) {
    if (!cookies.get("all_inclusive_modal")){
      // no cookie, open modal
      $.modal({
        url: '/fw/dialog/AllInclusiveModal.jsp',
        triggerOpen: open,
        onComplete: function() {
          cookies.set('all_inclusive_modal', true, { expires: 7 })
        }
      });
    }
  }

  $('.js-slides').each(function(i, item) {
    const $item = $(item);
    $item.slides({
      nextArrow: $('.js-slides').find('.slick-next'),
      prevArrow: $('.js-slides').find('.slick-prev'),
      showZoomTab: true,
    });
  });

  $('.js-carousel').each(function (i, item) {
    const $item = $(item);
    $item.slickSlider({
      lazyLoad: 'progressive',
      nextArrow: $item.find('.slick-next'),
      prevArrow: $item.find('.slick-prev'),
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
          {
              breakpoint: 832,
              settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
              }
          }
      ]
    });
  });

  $('.js-carousel-slide-3').each(function (i, item) {
    const $item = $(item);
    $item.slickSlider({
      lazyLoad: 'anticipated',
      nextArrow: $item.find('.slick-next'),
      prevArrow: $item.find('.slick-prev'),
      slidesToShow: 3,
      slidesToScroll: 3,
    });
  });


  $('.js-carousel__bag').each(function (i, item) {
    const $item = $(item);
    $item.slickSlider({
      nextArrow: $item.find('.slick-next'),
      prevArrow: $item.find('.slick-prev'),
      slidesToShow: 5,
      slidesToScroll: 5
    });
  });
  $('.js-carousel_rv').slick();


  $('.js-carousel--cpl').each(function (i, item) {
    const $item = $(item);
    $item.slickSlider({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      nextArrow: $item.find('.slick-next'),
      prevArrow: $item.find('.slick-prev'),
      responsive: [{
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      }]
    });
  });
  $('.js-carousel--dress-edit').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true
  });

  $('.js-add-on').recsPopOut();
  $('.js-scroll-to-top').scrollToTop();
  $('.js-countdown').countdown();
  $('.js-gfc-update').giftCertUpdate();
  $('.js-focus-to').focusTo();
  $('.js-switch-class').switchClass();
  $('.js-toggle-text').toggleText();
  $('.js-close-banner').closeBanner();
  $.modal.a11y();
  $('.js-char-counter').charCounter();
  $('.js-fixed-table-header').fixedTableHeader();
  $('.js-tooltip').tooltip();
  $('.js-toggle-change').toggleChange();
  $('.js-product-opt-view').productOptView();
  $('.js-progress-ring').progressRing();
  $('.js-slidedown').slidedown();
  $('.js-progressive-btn').progressiveBtn();
  $('.js-ab-controls').abControls(); // Ab Testing Controls for previewing on testing servers
  $('.js-impressions-controls').impressionsControls();
  $('.js-mask-cc').ccMask();
  $('#js-carousel-ctl').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3
  });

  //PDP Slider
  const initializePDPImageCarousel = () => {
    $('#js-carousel-pdp').not('.slick-initialized').slick({
      lazyLoad: 'progressive',
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: true,
      arrows: true
    });
  }
  initializePDPImageCarousel();

  // Reinitialize slick if the window height is less than X number of pixels
  // Smaller height PDP carousel was implemented so image isn't too big on
  // laptops
  let hasSlickInitiated = true;
  let hasSmallerSlickInitiated = false;
  $(window).resize((event) => {
    if($(window).height() < 900 && hasSlickInitiated) {
      $('#js-carousel-pdp').slick('unslick'); // Destroy the larger slick instance
      initializePDPImageCarousel();
      hasSlickInitiated = false;
      hasSmallerSlickInitiated = true;
    }
    if($(window).height() >= 900 && hasSmallerSlickInitiated) {
      $('#js-carousel-pdp').slick('unslick'); // Destroy the smallerslick instance
      initializePDPImageCarousel();
      hasSlickInitiated = true;
      hasSmallerSlickInitiated = false;
    }
  });

  //Global Banner slider
  const bannerSlideshow = $('.js-slideshow');
  if (bannerSlideshow.children('.banner--slider-list__item').length > 1) {
    bannerSlideshow.slick({
      autoplay: true,
      autoplaySpeed: 6000,
      prevArrow: '.banner__slick-prev',
      nextArrow: '.banner__slick-next',
    });
    $('.banner__slick-next, .banner__slick-prev').on('click', () => {
      bannerSlideshow.slick('slickPause');
    });
  }
  $('#js-carousel-pdp').on('afterChange', function(event, slick, currentSlide, nextSlide){
    var x = $(document).scrollLeft(), y = $(document).scrollTop();
    $(slick.$slides.get(currentSlide)).find('img.product-detail-image').attr('tabindex', 0).focus();
    $('html, body').animate({
      scrollTop: y
    }, 0);
  });
  // JS for CTL in ATB modal
  const jsCarouselCtlAtb = $('.js-carousel-ctl-atb');
  // if more than 3 items initialize carousel
  if(jsCarouselCtlAtb.children('.pdp__ctl-slide').length > 3) {
    jsCarouselCtlAtb.slick({
      lazyLoad: 'ondemand',
      slidesToShow: 3,
      slidesToScroll: 3,
      accessibility: true
    });
  }
// input mask
 if ($('.js-mask-tel-us').length) {
  $('.js-mask-tel-us').mask('+1(000) 000-0000');
 }
 //UX-17699 AB Test
 if ($('.js-mask-tel-us-ab').length) {
  $('.js-mask-tel-us-ab').mask('(000) 000-0000');
 }
 if ($('.js-mask-date').length) {
   $('.js-mask-date').mask('00/00/0000');
 }
 if ($('.js-mask-month-day').length) {
   $('.js-mask-month-day').mask('00/00');
 }
  $('.js-enterable').enterable();
  $(".js-track-video").trackVideo();
  $(".js-modal").modal();
  $('.js-accordion').accordion();
  $('.js-dropdown').dropdown();
  $('.js-nav-primary__item').navActive();
  $('.js-toggle-display').toggleDisplay();
  $('.js-toggle-reveal').toggleReveal();
  // $('.product-option--size .product-option__select').sizeChange();
  // $('.product-option--color .product-option__select').colorChange();
  // $('.btn--add-to-bag').addToBag();
  // $('.product-option--oos').oosProduct();
  $(document.getElementsByClassName('vanish')).vanish();

  // JS Remove Element - used for filters attributeSetterService
  $('.js-selected-filter').on('click', function(e){
    e.preventDefault();
    var element = $(this);
    element.remove();
  });

  // Initialize lazy load on image with class name
  $('.js-lazy-image').lazy({
    bind: 'event',
    effect: 'fadeIn',
    effectTime: 500,
    threshold: 0
  });

  // lazy loading for images for shopping bag and shopping bag carousels
  $('.js-order-lazy-img').lazy({
    bind: 'event',
    effect: 'fadeIn',
    effectTime: 500,
    threshold: 0
  });

  // Special Launches Hero Slider
  $('.js-slick-launches').each(function () {
    const $this = $(this);
    $this.slickSlider({
      dots: true,
      appendDots: $this.find('.js-pagination-dots'),
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
    }).on('afterChange', function (event, slick, currentSlide) {
      $.each(slick.$dots, (i, el) => {
        $(el).find('li').eq(currentSlide).addClass('slick-active').find('button');
      })
    });
  });

  // Call the function initially and after slide changes
  $('.js-slick-launches').on('init afterChange', setSliderHeight);

  function setSliderHeight() {
    let minHeight = Infinity; // Start with infinity to find the *shortest*
    const lvHeight = $('.js-slick-launches .slick-slide img.landscape-view').first();

    if (lvHeight) {
      minHeight = lvHeight.height();
    } else {
      $('.js-slick-launches .slick-slide img').each(function () {
        // Get the height of the image. Important!
        const imgHeight = $(this)[0].height;
        if (imgHeight < minHeight) {
          minHeight = imgHeight;
        }
      });
    }

    // Set the height of the necessary elements - N/A to this implementation
    // $('.js-slick-launches .slick-list, .slick-track, .slick-slide, .js-slick-launches').height(minHeight);

    // Set image width to auto and the height to the shortest image (should be the landscape img )
    $('.js-slick-launches .slick-slide img.portrait-view').css({
      'height': minHeight,
      'width': 'auto',
    });
  }

  // Recalculate height on window laod and resize (important for responsiveness)
  window.addEventListener("load", setSliderHeight);
  window.addEventListener("resize", setSliderHeight);

  // launches carousels
  $('.js-carousel--three').each(function () {
    const $this = $(this);
    $this.slickSlider({
      slidesToShow: 3,
      slidesToScroll: 3,
      nextArrow: $this.children('.slick-next'),
      prevArrow: $this.children('.slick-prev'),
    });
  });

  // launches left carousel
  $('.js-spotlight-left').slick({
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });

  function positionSlickArrows(e) {
    const $slick = $('.js-spotlight-left.slick-slider');
    const $sliickNextArrow = $('.js-spotlight-left .slick-next');
    const $slides = $slick.find('.slick-slide');
    const $currentSlide = $slides.filter((index, slide) => $(slide).hasClass('slick-current'));
    const slideImageWidth = ($currentSlide.find('img').width());
    $sliickNextArrow.css('left', slideImageWidth + 'px');
    setTimeout(function(){
      $sliickNextArrow.css('opacity', 1);
    }, 200);
  }

  $(window).on("load", function () {
    $(window).trigger('resize');
  });

  $(window).resize(debounce(positionSlickArrows, 100));

  // Forms
  var $formModals = $('.js-special-launch-forms');
  $($formModals).each(function (index) {
    var $this = $(this);
    var $formButton = $(this).find('button');
    $formButton.on('click', function (e) {
      e.preventDefault();
      $this.hide();
      $this.next().show();
    });
  });

  /* Enable Button when checkbox is checked */
  $('.js-enter-checkbox').find('input[type="checkbox"]').on('change', function () {
    if ($('.js-enter-checkbox').find('input[type="checkbox"]').is(':checked')) {
      $('.js-enter-checkbox').closest($formModals).find('button').prop("disabled", false);
    }
  });
};



$(document).ready(initModules);
$(window).on('content-load', initModules);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/modules.js